import { useState } from "react";
import { ToolPageShell } from "@/components/AdminTools";
import { Rocket } from "lucide-react";

import { TABS } from "./founder/constants";
import DashboardView from "./founder/DashboardView";
import TasksView from "./founder/TasksView";
import { ClinicPipelineView, VendorPipelineView } from "./founder/PipelineView";
import FeedbackView from "./founder/FeedbackView";
import CalendarView from "./founder/CalendarView";

// Founder Operating System — thin orchestrator. Each tab is a self-contained
// view under /admin/founder/. Constants + shared modal primitives live in
// founder/constants.js and founder/_shared.jsx so dialogs stay consistent.
export default function FounderOS() {
  const [tab, setTab] = useState("dashboard");
  return (
    <ToolPageShell
      eyebrow={
        <span className="inline-flex items-center gap-1.5 text-blue-700">
          <Rocket className="w-3.5 h-3.5" /> Execute the Vision
        </span>
      }
      title="Founder Operating System"
      intro="A lightweight founder execution system focused on momentum, accountability, and launch execution. Simple systems that drive execution outperform bloated systems that create operational overhead."
    >
      <div className="border-b border-slate-200 mb-5 -mx-2 px-2 overflow-x-auto">
        <div className="flex items-center gap-1" data-testid="founder-os-tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              data-testid={`founder-os-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`inline-flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-semibold transition-colors border-b-2 -mb-[2px] ${
                tab === t.id
                  ? "text-slate-900 border-slate-900"
                  : "text-slate-500 hover:text-slate-900 border-transparent"
              }`}
            >
              <t.icon className="w-3.5 h-3.5" />
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === "dashboard" && <DashboardView />}
      {tab === "tasks" && <TasksView />}
      {tab === "clinics" && <ClinicPipelineView />}
      {tab === "vendors" && <VendorPipelineView />}
      {tab === "feedback" && <FeedbackView />}
      {tab === "calendar" && <CalendarView />}
    </ToolPageShell>
  );
}
